import { Container, Header, Button, SpaceBetween } from "@cloudscape-design/components"

export default function Home(){
    return(
      <SpaceBetween  size="xl">
        <Container
            header={<Header variant="h2">Well Done Entertainment Development Portal</Header>}
        >
        </Container>
        <Container
            header={<Header variant="h3">Useful Links</Header>}
        >

          <SpaceBetween  size="m" >
            <Button  href="https://welldoneentertainment.atlassian.net/wiki/spaces/Engineerin/pages/18415620/Developer+Set+Up+Guide"
              external
              externalIconAriaLabel="Opens in a new tab"
            >
              Dev Setup
            </Button>
            <Button  href="https://docs.google.com/document/d/1R3gsRG5V4qPbRMQPC2j03CzsPyv9H01eSlTpl89rR_4/edit?usp=sharing"
              external
              externalIconAriaLabel="Opens in a new tab"
            >
              Play Test Setup
            </Button>
          </SpaceBetween>
        </Container>
        <Container
            header={<Header variant="h3">Tools</Header>}
        >
            <SpaceBetween  size="m">
              <Button  href="https://vpn.wde.ninja"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                VPN
              </Button>
              <Button  href="https://cr.p4.wde.ninja"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                Swarm
              </Button>
              <Button  href="https://horde.wde.ninja/"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                Horde
              </Button>
              <Button  href="https://stakeworldworkspace.slack.com"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                Slack
              </Button>
              <Button  href="https://miro.com/"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                Miro
              </Button>
              <Button  href="https://welldoneentertainment.atlassian.net/jira/your-work"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                Jira
              </Button>
              <Button  href="https://welldoneentertainment.atlassian.net/wiki/spaces/WDE/overview?homepageId=852223"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                Confluence
              </Button>
              
              <Button  href="https://tsd.wde.ninja/"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                TwoShakes
              </Button>
              <Button  href="https://d-9c676ff3ac.awsapps.com/start"
                external
                externalIconAriaLabel="Opens in a new tab"
              >
                AWS Console
              </Button>
            </SpaceBetween>
        </Container>
      </SpaceBetween>
    )
}